import { render } from "./WebOrdersView.vue?vue&type=template&id=726fbe32&scoped=true"
import script from "./WebOrdersView.vue?vue&type=script&lang=js"
export * from "./WebOrdersView.vue?vue&type=script&lang=js"

import "./WebOrdersView.vue?vue&type=style&index=0&id=726fbe32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726fbe32"]])

export default __exports__